import strings from '../../../globalization';
import moment from 'moment';

export const getFormData = () => {
  return {
    left: [
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'alphabets',
        label: strings.personName,
        placeholder: strings.enterFullName,
        required: true,
        stateField: 'individualName',
        stateDefault: '',
        minLength: 3,
        maxLength: 128,
        dependentOnOtherFields: false,
      },
      {
        inputType: 'phone',
        elementType: 'phone',
        keyboardType: 'number-pad',
        label: strings.personPhoneNumber,
        placeholder: strings.personPhoneNumber,
        required: true,
        stateField: 'phoneNumber',
        stateDefault: '',
        maxLength: 10,
        verifyOtp: true,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'dropdown',
        inputType: 'text',
        label: strings.gender,
        placeholder: strings.selectGender,
        optionsField: 'genderOptions',
        required: true,
        stateField: 'gender',
        stateDefault: null,
        maxLength: 20,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'number',
        label: strings.aadharNumberField,
        placeholder: strings.aadharNumberPlaceholder,
        required: true,
        stateField: 'aadhaarNumber',
        stateDefault: null,
        minLength: 12,
        maxLength: 12,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'dropdown',
        inputType: 'text',
        label: strings.personTypeField,
        placeholder: strings.personTypePlaceholder,
        optionsField: 'personTypeOptions',
        required: true,
        stateField: 'personType',
        stateDefault: null,
        maxLength: 20,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'dropdown',
        inputType: 'dropdown',
        label: strings.department,
        placeholder: strings.selectDepartment,
        optionsField: 'deptOptions',
        required: true,
        stateField: 'departmentId',
        stateDefault: null,
        maxLength: 20,
        dependentOnOtherFields: false,
      },

      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.drivingLicenseDocumentField,
        placeholder: strings.drivingLicenseDocumentPlaceholder,
        required: true,
        stateField: 'drivingLicenceDocument',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],
        maxFiles: 1,
        dependentOnOtherFields: true,
      },

      // {
      //   elementType: "dropdown",
      //   inputType: "text",
      //   label: strings.countryField,
      //   placeholder: strings.countryPlaceholder,
      //   optionsField: "countryOptions",
      //   required: true,
      //   stateField: "country",
      //   stateDefault: null,
      //   maxLength: 20,
      // },

      // {
      //   elementType: 'text',
      //   keyboardType: 'default',
      //   inputType: 'text',
      //   label: strings.documentProofNumber,
      //   placeholder: strings.documentProofNumber,
      //   required: true,
      //   stateField: 'aadhaarPanDrivingLicenseNumber',
      //   stateDefault: null,
      //   minLength: 5,
      //   maxLength: 20,
      // },
      // {
      //   elementType: 'date',
      //   keyboardType: 'default',
      //   inputType: 'date',
      //   label: strings.documentValidity,
      //   placeholder: strings.selectDate,
      //   required: true,
      //   disable: false,
      //   stateField: 'documentValidity',
      //   stateDefault: null,
      //   maxLength: 20,
      //   minimumDate: new Date(),
      //   dependentOnOtherFields: false,

      // },

      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.uploadSafetyCertificate,
        placeholder: strings.selectDocument,
        required: false,
        stateField: 'safetyDocument',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],
        maxFiles: 1,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.officialContractDocument,
        placeholder: strings.selectDocument,
        required: false,
        stateField: 'officialContractDocument',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],
        maxFiles: 1,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.uploadMedicalCertificate,
        placeholder: strings.selectMedicalCertificate,
        required: false,
        stateField: 'medicalCertificate',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],

        maxFiles: 1,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.uploadPoliceNOC,
        placeholder: strings.selectPoliceNOC,
        required: false,
        stateField: 'policeNOCCertificate',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],

        maxFiles: 1,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'companyName',
        label: strings.companyName,
        placeholder: strings.enterCompanyName,
        required: true,
        stateField: 'companyName',
        stateDefault: '',
        minLength: 5,
        maxLength: 128,
        dependentOnOtherFields: false,
        uppercase: true,
      },
    ],
    right: [
      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'email',
        label: strings.personEmail,
        placeholder: strings.enterEmail,
        required: true,
        stateField: 'emailAddress',
        stateDefault: null,
        maxLength: 50,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'uploadphoto',
        inputType: 'uploadContainer',
        label: strings.individualPhoto,
        placeholder: strings.chooseFile,
        required: true,
        stateField: 'individualPhoto',
        // FIXME
        stateDefault: [],

        maxFiles: 1,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.dob,
        placeholder: strings.selectDate,
        required: true,
        stateField: 'dateOfBirth',
        stateDefault: null,
        maxLength: 20,
        maximumDate: new Date(),
        dependentOnOtherFields: false,
      },

      // {
      //   elementType: "text",
      //   keyboardType: "default",
      //   inputType: "alphabets",
      //   label: "Nationality",
      //   placeholder: "Enter nationality",
      //   required: true,
      //   stateField: "nationality",
      //   stateDefault: null,
      //   maxLength: 50,
      // },

      {
        elementType: 'file',
        inputType: 'upload',
        label: strings.aadharNumberDocumentField,
        placeholder: strings.aadharNumberDocumentPlaceholder,
        required: true,
        stateField: 'aadhaarDocument',
        // FIXME
        stateDefault: [],
        allowedFormats: ['pdf', 'images'],
        maxFiles: 1,
        dependentOnOtherFields: false,
      },

      {
        elementType: 'text',
        keyboardType: 'default',
        inputType: 'alphanumeric',
        label: strings.drivingLicenseField,
        placeholder: strings.drivingLicensePlaceholder,
        required: true,
        stateField: 'drivingLicenceNumber',
        stateDefault: '',
        minLength: 10,
        maxLength: 17,
        dependentOnOtherFields: true,
        uppercase: true,
      },

      // {
      //   elementType: 'dropdown',
      //   inputType: 'dropdown',
      //   label: strings.documentTypeField,
      //   placeholder: strings.documentTypePlaceholder,
      //   optionsField: 'documentTypeOptions',
      //   required: true,
      //   stateField: 'documentType',
      //   stateDefault: null,
      //   maxLength: 20,
      // },

      // {
      //   elementType: 'file',
      //   inputType: 'upload',
      //   label: strings.uploadDocumentField,
      //   placeholder: strings.uploadDocumentPlaceholder,
      //   required: true,
      //   stateField: 'document',
      //   // FIXME
      //   stateDefault: [],
      //   allowedFormats: ['pdf', 'images'],

      //   maxFiles: 1,
      // },
      // {
      //   elementType: "dropdown",
      //   inputType: "text",
      //   label: strings.countryField,
      //   placeholder: strings.countryPlaceholder,
      //   optionsField: "countryOptions",
      //   required: true,
      //   stateField: "country",
      //   stateDefault: null,
      //   maxLength: 20,
      // },
      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.drivingLicenseValidity,
        placeholder: strings.drivingLicenseValidityPlaceholder,
        required: true,
        disable: false,
        stateField: 'drivingLicenceValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
        dependentOnOtherFields: true,
      },
      {
        elementType: 'dropdown',
        inputType: 'text',
        label: strings.bloodGroup,
        placeholder: strings.bloodGroupPlaceholder,
        optionsField: 'bloodGroupOptions',
        required: true,
        stateField: 'bloodGroup',
        stateDefault: null,
        maxLength: 20,
        dependentOnOtherFields: false,
      },
      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.safetyCertificateValidity,
        placeholder: strings.selectDate,
        required: false,
        stateField: 'safetyCertificateValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
        dependentOnOtherFields: false,
      },

      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.medicalCertificateValidity,
        placeholder: strings.selectDate,
        required: false,
        stateField: 'medicalCertificateValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
        dependentOnOtherFields: false,
      },
      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.officialContractDocumentValidity,
        placeholder: strings.selectDate,
        required: false,
        stateField: 'officialContractDocumentValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
        dependentOnOtherFields: false,
      },

      {
        elementType: 'date',
        keyboardType: 'default',
        inputType: 'date',
        label: strings.policeNOCValidity,
        placeholder: strings.selectDate,
        required: false,
        stateField: 'policeNOCValidity',
        stateDefault: null,
        maxLength: 20,
        minimumDate: new Date(),
        dependentOnOtherFields: false,
      },
      {
        elementType: 'text',
        inputType: 'alphanumeric',
        label: `GST Number`,
        placeholder: `Enter GST Number`,
        required: false,
        stateField: 'GSTNumber',
        stateDefault: '',
        minLength: 10,
        maxLength: 15,
        dependentOnOtherFields: false,
      },
    ],
  };
};

export const termsData = [
  {
    title: 'DEFINITIONS',
    content: '"Agreement" shall mean the terms and conditions of use.',
  },
  {
    title: '',
    content:
      '"Application" shall mean the application [e-Drishti] supplied by the Company and downloaded and installed by you on your mobile device, tablet, laptop, computer, etc.',
  },
  {
    title: '',
    content:
      '"Company", "we", "our" and "us" shall mean-- KR mroads India Pvt. Ltd.',
  },
  {
    title: '',
    content:
      '"You" shall mean You, the User of the Website/ Application and "Yourself" interpreted accordingly. ',
  },
  {
    title: '',
    content:
      '"Users" means the Users of the Website/ application collectively and/or individually as the context allows.',
  },
  {
    title: 'Acknowledgement',
    content:
      'Visitors to this website- www.sanya.ai/edrishti are bound by the following terms and conditions ("terms").',
  },
  {
    title: '',
    content:
      'If you do not agree with any of these terms, please do not proceed further with using the site.',
  },
  {
    title: '',
    content:
      'Your access to and use of the services in this website is also conditioned on your acceptance of and compliance with the privacy policy of the website.',
  },
  {
    title: '',
    content:
      'As a precondition to your use of the Services, you represent and warrant that:',
  },
  {
    title: '',
    content: 'The information you provide is accurate and complete.',
  },
  {
    title: '',
    content:
      'The Company (KR mroads India Pvt. Ltd.) is entitled, at all times, to verify the information that you have provided and to refuse the Services or use of the Application without providing any reasons whatsoever.',
  },
  {
    title: '',
    content:
      'You will only use our Services using authorized means. You are responsible to check and ensure you download the correct Application for your device. We will not be liable if you do not have a compatible device or if you download the wrong version of the Application for your device. The Company reserves the right to terminate.',
  },
  {
    title: '',
    content:
      'You specifically authorize us to use, store or otherwise process your data or information (in order to provide the Services to you.)',
  },
  {
    title: '',
    content:
      'You will obey all applicable laws related to the matters set forth herein, and will be solely responsible for any violations of the same.',
  },
  {
    title: '',
    content:
      'You agree that the information or data you provide in the form will or may be subjected to additional scrutiny or validation to prove authenticity. ',
  },
  {
    title: '',
    content:
      'You agree that upon agreement of the form, you will be redirected to the payment gateway and No Refunds will be given except in the event of non-performance or inexplicable errors by/from/of any service by www.sanya.ai/edrishti ',
  },
  {
    title: '',
    content:
      'You agree to receive recurring SMS/Email messages with service-related messages, including updates, alerts, and information.',
  },
];
